import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-storage',
  template: `
    <p>
      storage works!
    </p>
  `,
  styles: [
  ]
})
export class StorageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
